export default {
  title: 'MBD Team Detail Report',
  backButton: 'All reports',
  membershipFilterLabel: 'Filter by team members',
  export: 'Export',
  adminBackButton: 'Back to MBD Reports',
};
